import { Editor } from 'slate'

// Inline formatting marks on interaction text. Stored as plain booleans on
// Slate leaves (`{ text, bold: true }`) inside `formatted_text`, next to the
// existing highlight marks — the backend stores that JSON as-is.
export const FORMATS = ['bold', 'italic', 'underline']

export const SHORTCUTS = { b: 'bold', i: 'italic', u: 'underline' }

export function isFormatActive(editor, format) {
  const marks = Editor.marks(editor)

  return marks ? marks[format] === true : false
}

export function toggleFormat(editor, format) {
  if (isFormatActive(editor, format)) {
    Editor.removeMark(editor, format)
  } else {
    Editor.addMark(editor, format, true)
  }
}

// Returns the format for a Cmd/Ctrl+B/I/U keydown, or undefined.
export function formatForShortcut(event) {
  if (!(event.metaKey || event.ctrlKey) || event.altKey) {
    return undefined
  }

  return SHORTCUTS[event.key.toLowerCase()]
}
